// Firebase Configuration for FarmTrackPro
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAlv6vm04P1ATjlDekC1IKDTM1bYVDLb8A",
  authDomain: "farmtrackpro.firebaseapp.com",
  projectId: "farmtrackpro",
  storageBucket: "farmtrackpro.firebasestorage.app",
  messagingSenderId: "1001412952627",
  appId: "1:1001412952627:web:cdeeca3a0e90e65c35d946",
  measurementId: "G-56R4RBQ33Z"
};

// Google Drive API Configuration
export const googleConfig = {
  clientId: "471988173552-vt5dgqg8pulmmbnjkdno3eoohhug67gp.apps.googleusercontent.com",
  scope: "https://www.googleapis.com/auth/drive.file",
  discoveryUrl: "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export default app; 